import axios from 'axios';
import { URLS } from './urls';
import { APIUtils } from 'commons/utils';
import { useMutation } from 'react-query';
import { useRecoilState } from 'recoil';
import { tokenState } from 'redux-recoil-sync.state';

interface ModulePreviewRespons {
  id: string;
  filePath: string;
}

export function useGenerateModulePreview(id: string | undefined) {
  const [token] = useRecoilState(tokenState);

  return useMutation<ModulePreviewRespons, Error>(['programs', 'preview', { id }], async () => {
    try {
      const response = await axios.get<ModulePreviewRespons>(URLS.programs(id!).preview(), APIUtils.tokenHeader(token!));
      return response.data;
    } catch (e) {
      throw axios.isAxiosError(e) && e.response?.data.message ? new Error(e.response?.data.message) : e;
    }
  });
}
